import type { MainAttachmentsSkin } from '@/deskUiSkeletons/Page/MainAttachments'

// Std visual class tokens for the shared main-attachments skeleton
// (25_SHARED_DESKUI_SKELETON.md §4.6). These byte-replicate the
// pre-extraction strings; change freely — std-only look.
export const mainAttachmentsSkin: MainAttachmentsSkin = {
  empty: 'flex min-h-[220px] items-center justify-center text-[13px] text-[#64748b]',
  root: 'flex min-h-0 w-full flex-1 flex-col gap-4 px-5 pb-5 pt-3 text-[#0f172a]',
  header: 'flex items-center justify-between border-b border-[#e2e8f0] pb-2',
  title: 'text-[15px] font-semibold',
  count: 'text-[12px] text-[#64748b]',
  body: 'grid min-h-0 flex-1 grid-cols-[minmax(0,1fr)_150px] gap-4',
  preview: 'flex min-h-[320px] items-center justify-center overflow-hidden rounded-lg border border-[#e2e8f0] bg-[#f8fafc] p-3',
  image: 'max-h-[70vh] max-w-full object-contain',
  side: 'flex min-h-0 flex-col gap-3',
  meta: 'rounded-lg border border-[#e2e8f0] p-3',
  metaTitle: 'break-words text-[13px] font-semibold',
  metaDescription: 'mt-1 break-words text-[12px] leading-5 text-[#64748b]',
  nav: 'flex gap-2',
  button: 'flex-1 rounded-md border border-[#cbd5e1] px-2 py-1.5 text-[12px] font-semibold text-[#334155]',
  thumbs: 'grid max-h-[calc(70vh-110px)] grid-cols-2 gap-2 overflow-auto pr-1',
  thumb: 'rounded-md border p-1',
  thumbSelected: 'border-[#2563eb] bg-[#eff6ff]',
  thumbUnselected: 'border-[#e2e8f0] bg-white',
  thumbImage: 'h-16 w-full object-cover',
}
